<template>

      <v-card min-height="200px">
        <v-row class="d-flex justify-space-around">
          
          <div class="oneStyle">
            <v-card class="pa-2" flat>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/charme-001.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/charme-001.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/charme-002.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/charme-002.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/charme-003.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/charme-003.jpg?thumb=true" cover class="my-1"></v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="style" @change="$emit('change', style)">
                  <v-radio value="charme" label="Charme"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </div>

          <div class="oneStyle">
            <v-card class="pa-2" flat>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/boheme-001.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/boheme-001.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/boheme-002.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/boheme-002.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/boheme-003.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/boheme-003.jpg?thumb=true" cover class="my-1"></v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="style" @change="$emit('change', style)">
                  <v-radio value="boheme" label="Bohème"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </div>

          <div class="oneStyle">
            <v-card class="pa-2" flat>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/nature-001.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/nature-001.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/nature-002.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/nature-002.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/nature-003.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/nature-003.jpg?thumb=true" cover class="my-1"></v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="style" @change="$emit('change', style)">
                  <v-radio value="nature" label="Nature"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </div>

          <div class="oneStyle">
            <v-card class="pa-2" flat>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/design-001.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/design-001.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/design-002.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/design-002.jpg?thumb=true" cover class="my-1"></v-img>
              <v-img height="150px" src="/gimc/storage/assets/themes/leroymerlin/design-003.jpg?height=150" lazy-src="/gimc/storage/assets/themes/leroymerlin/design-003.jpg?thumb=true" cover class="my-1"></v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="style" @change="$emit('change', style)">
                  <v-radio value="design" label="Design"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </div>

        </v-row>
        <v-card-actions v-if="!!style">
          <v-btn outlined color="#0b755f" @click="$emit('change', style)" >Suivant</v-btn>
        </v-card-actions>
      </v-card>
</template>

<script>
export default {
  model: { prop: 'data', event: 'change' },
  props: {
    data: String
  },
  data: () => ({
    style: ''
  }),
  beforeMount () {
    this.style = this.data
  }
}
</script>

<style scoped>
.oneStyle {
  margin: 12px 0 0 0;
  width: 234px;
  border-right: 1px solid #c1c1c1;
}
</style>